import { Component } from "react";
import { ICustomer } from "../../api/models/Customer";

import * as React from "react";

import "./CustomerForm.css"

interface ICustomerFormProps {
	onChange: (newCustomer: ICustomer) => void;
}

interface ICustomerFormState {
	error: string;
}

export class CustomerForm extends Component<ICustomerFormProps, ICustomerFormState> {
	public constructor(props: ICustomerFormProps) {
		super(props);

		this.handleCustomerUpdate = this.handleCustomerUpdate.bind(this);
		this.validateFields = this.validateFields.bind(this);

		this.state = {
			error: ""
		}
	}

	public render() {
		return (
			<div className="grid-x grid-margin-x customer-form">
				<div className="cell small-6">
					<label> 
						Vorname
						<input type="text" required={true} name="" id="fake-firstName" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-6">
					<label> 
						Nachname
						<input type="text" required={true} name="" id="fake-lastName" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-5">
					<label> 
						Strasse + Hausnummer
						<input type="text" required={true} name="" id="fake-street" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-5">
					<label> 
						Stadt
						<input type="text" required={true} name="" id="fake-city" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-2">
					<label> 
						PLZ
						<input type="number" required={true} name="" id="fake-zip" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-12">
					<label> 
						E-Mail
						<input type="email" required={true} name="" id="fake-email" onChange={this.handleCustomerUpdate}/>
					</label>
				</div>
				<div className="cell small-12">
					<p style={{ color: "red" }}>
						{this.state.error}
					</p>
				</div>
			</div>
		)
	}

	private handleCustomerUpdate() {
		const customer: ICustomer = {
			city: (document.getElementById("fake-city") as HTMLInputElement).value,
			email: (document.getElementById("fake-email") as HTMLInputElement).value,
			firstName: (document.getElementById("fake-firstName") as HTMLInputElement).value,
			lastName: (document.getElementById("fake-lastName") as HTMLInputElement).value,
			street: (document.getElementById("fake-street") as HTMLInputElement).value,
			zip: (document.getElementById("fake-zip") as HTMLInputElement).value,
		}
		this.props.onChange(customer);
	}

	/**
	 * @returns `true` if all fields are valid.
	 * @returns `false` if at least one of the fields is invalid.
	 */
	private validateFields(): boolean {
		const city = (document.getElementById("fake-city") as HTMLInputElement).value;
		const email = (document.getElementById("fake-email") as HTMLInputElement).value;
		const firstName = (document.getElementById("fake-firstName") as HTMLInputElement).value;
		const lastName = (document.getElementById("fake-lastName") as HTMLInputElement).value;
		const street = (document.getElementById("fake-street") as HTMLInputElement).value;
		const zip = (document.getElementById("fake-zip") as HTMLInputElement).value;

		if (city === undefined || city === null || city === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else if (email === undefined || email === null || email === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else if (firstName === undefined || firstName === null || firstName === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else if (lastName === undefined || lastName === null || lastName === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else if (street === undefined || street === null || street === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else if (zip === undefined || zip === null || zip === "") {
			this.setState({ error: "Bitte füllen Sie alle Felder aus!" });
		} else {
			this.setState({ error: "" });
			return true;
		}

		return false;
	}
}


// WEBPACK FOOTER //
// ./src/components/form/CustomerForm.tsx